// extracted by mini-css-extract-plugin
module.exports =  {"PictureInPictureButton":"WxeN30BQxU4lexsfS3Ib"};